//@flow
import React from 'react'
import regionsMap from './images/regionen.svg'
import './styles.scss'


export class Regions extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }
  
  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {

    return <div className='regions'>
      <h3>Pünktlichkeit nach Regionen im Jahr 2022</h3>
      <img src={regionsMap} alt='karte' />
      <div className="source">Quelle: <a href='https://news.sbb.ch/medien/artikel/115696/gute-puenktlichkeit-2022-sbb-will-niveau-trotz-vieler-baustellen-in-naechsten-jahren-halten'>SBB</a></div>
    </div>
  }
}



             